import { CrudPage } from '@restavo/crud';
import React from 'react';
import { inventoryCategoriesPage } from 'src/features/inventoryCategories';

const InventoryCategories = React.memo(() => <CrudPage {...inventoryCategoriesPage} />);

export default InventoryCategories;
